import { useCallback, useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { ContentWrapper } from '../../_common';
import srv from '../../../services';
import moment from 'moment';
import SelectContract from '../../_common/SelectContract';
import SelectConnection from '../../_common/SelectConnection';
import { Select } from 'antd';
import {
 SelectBlock,
 TableHead,
 TableRow,
 TableBody,
 Spinner,
 SelectTypeDevice,
 TableAccruals,
 SubmitButton,
} from '../MeteringDevices.styled';
import React from 'react';
import { utils, writeFile } from 'xlsx';
import { DatePicker, Space } from 'antd';
const { RangePicker } = DatePicker;

export default function MeteringHistory() {
 const {
  changeContract,
  changeConnection,
  changeTypeDevice,
  handleDateRangeValues,
  dateFrom,
  dateTo,
  defaultDateRange,
  typeDevice,
  contractNumber,
  meteringDevice,
  meterings,
  connections,
  contracts,
  onFinish,
  onFinishAskue,
  isLoading,
  accruals,
  accrualsAskue,
 } = useAccruals();

 const [askueValue, setAskueValue] = useState<boolean>(false);
 const [mainGrid, setMainGrid] = useState([]);
 const [secondGrid, setSecondGrid] = useState([]);

 useEffect(() => {
  setAskueValue(false);
 }, [contracts, connections, meterings]);

 useEffect(() => {
  if (meterings && meterings.length > 0) {
   const data = meterings.filter(
    (x) => x.meteringDeviceId === typeDevice
   ) as any;

   if (data && data.length > 0) {
    setAskueValue(data[0].askue);
   }

   /**
    * convert data to excell
    */
   const JsonData = accrualsAskue;

   if (JsonData && JsonData.values) {
    const inputData = JsonData.values;
    const uniqueDates = Array.from(new Set(inputData.map((item) => item.date)));
    interface readyObject {
     period: string;
     date: string;
     amount: string;
    }

    let readyArray: readyObject[] = [];

    if (uniqueDates && uniqueDates.length > 0) {
     uniqueDates.map((element: any) => {
      const foundRecord = inputData.filter((x) => x.date === element);

      if (foundRecord && foundRecord.length > 0) {
       const sum = foundRecord.reduce(
        (a, v) => (a = a + Number(v.value.replaceAll(',', '.'))),
        0
       );

       const selectedDate = moment(element, 'DD.MM.YYYY');

       const correctDate = moment(selectedDate, 'DD.MM.YYYY');
       const period = moment(correctDate, 'DD.MM.YYYY').format('MMMM, YYYY');

       const data: readyObject = {
        period: period,
        date: moment(correctDate).format('DD.MM.YYYY'),
        amount: sum,
       };

       readyArray.push(data);
      }
     });
     setMainGrid(readyArray);
     setSecondGrid(inputData);
    }
   }
  }
 }, [accruals, accrualsAskue]);

 const exportData = () => {
  const customHeaderSheet1 = [
   'Период',
   'Дата и время',
   'Суммарная активная энергия, КВтч',
  ];

  const customHeaderSheet2 = [
   'Дата',
   'Время (час)',
   'Активная энергия (прием)',
  ];

  const ws1Input = utils.json_to_sheet(mainGrid, {
   header: ['period', 'date', 'amount'],
  });
  const ws2Input = utils.json_to_sheet(secondGrid, {
   header: ['date', 'time', 'value'],
  });

  ws1Input['A1'].v = customHeaderSheet1[0];
  ws1Input['B1'].v = customHeaderSheet1[1];
  ws1Input['C1'].v = customHeaderSheet1[2];

  ws2Input['A1'].v = customHeaderSheet2[0];
  ws2Input['B1'].v = customHeaderSheet2[1];
  ws2Input['C1'].v = customHeaderSheet2[2];

  let wb = utils.book_new(),
   ws1 = ws1Input,
   ws2 = ws2Input;
  utils.book_append_sheet(wb, ws1, 'Показания (суточные и текущие)');
  utils.book_append_sheet(wb, ws2, 'Инкрементальные данные');
  writeFile(wb, 'Список показаний.xlsx');
 };

 return (
  <ContentWrapper>
   <SelectBlock>
    <SelectContract
     changeContract={changeContract}
     contracts={contracts}
     value={contractNumber}
    />
    {contractNumber !== null && contractNumber !== undefined ? (
     <SelectConnection
      changeConnection={changeConnection}
      connections={connections}
      value={meteringDevice}
     />
    ) : null}
    {meteringDevice !== null && meteringDevice !== undefined ? (
     <SelectTypeDevice
      showSearch
      optionFilterProp="children"
      placeholder="Выберите ПУ"
      value={typeDevice}
      onChange={(value) => {
       changeTypeDevice(value);
       onFinish(value);
      }}
      loading={isLoading}
     >
      {meterings?.map((item) => (
       <Select.Option key={item.meteringDeviceId} value={item.meteringDeviceId}>
        {item.meteringDeviceNumber}
       </Select.Option>
      ))}
     </SelectTypeDevice>
    ) : null}

    {meteringDevice !== null &&
    meteringDevice !== undefined &&
    askueValue &&
    accruals &&
    accruals?.length > 0 ? (
     <RangePicker
      allowClear
      format="DD.MM.YYYY"
      style={{ width: '400px', marginRight: '10px' }}
      onChange={(value) => {
       handleDateRangeValues(value);
       onFinishAskue(value, typeDevice);
      }}
      defaultValue={defaultDateRange}
     />
    ) : null}

    {meteringDevice !== null &&
    meteringDevice !== undefined &&
    askueValue &&
    accruals &&
    accruals?.length > 0 ? (
     <SubmitButton
      disabled={!dateFrom || !dateTo || !defaultDateRange}
      style={{
       background: 'linear-gradient(#fff, #fff) padding-box',
       width: '200px',
      }}
      onClick={exportData}
     >
      Экспорт в Excell
     </SubmitButton>
    ) : null}
   </SelectBlock>

   {isLoading ? (
    <Spinner size="large" />
   ) : accruals === undefined ? null : (
    <TableAccruals>
     <TableHead>
      <TableRow>
       <th scope="col">Шкала</th>
       <th scope="col">Показания</th>
       <th scope="col">Дата показаний</th>
      </TableRow>
     </TableHead>
     {accruals?.map((accruals, index) => {
      return (
       <TableBody key={index}>
        <>
         <TableRow key={index}>
          <td>
           {accruals?.values.map((val) => {
            return <div>{val.name}</div>;
           })}
          </td>
          <td>
           {accruals?.values.map((val) => {
            return <div>{val.value}</div>;
           })}
          </td>
          <td>{moment(accruals?.dataValue).format('DD.MM.YYYY')}</td>
         </TableRow>
        </>
       </TableBody>
      );
     })}
    </TableAccruals>
   )}
  </ContentWrapper>
 );
}

function useAccruals() {
 const queryClient = useQueryClient();
 const contracts = queryClient.getQueryData<Models.Contract[]>('contracts');
 const [contractNumber, setContractId] = useState<number>(null);
 const [meteringDevice, setMeteringDevice] = useState<number>(null);
 const [typeDevice, setTypeDevice] = useState<string>(null);
 const [dateFrom, setDateFrom] = useState<string>(null);
 const [dateTo, setDateTo] = useState<string>(null);
 const [defaultDateRange, setDefaultDateRange] = useState(null);

 const changeContract = (value) => {
  setContractId(value);

  setTypeDevice(null);
  setMeteringDevice(null);
  onFinish(null);
  setDefaultDateRange(null);

  if (setContractId) {
   setMeteringDevice(null);
   setTypeDevice(null);
   setDefaultDateRange(null);
  }
 };

 const changeConnection = (value) => {
  setMeteringDevice(value);

  setTypeDevice(null);
  onFinish(null);
  setDefaultDateRange(null);

  if (setMeteringDevice) {
   setTypeDevice(null);
   setDefaultDateRange(null);
  }
 };

 const changeTypeDevice = (value) => {
  setTypeDevice(value);

  if (!value) {
   setTypeDevice(null);
   onFinish(null);
   setDefaultDateRange(null);
  }
 };

 const handleDateRangeValues = (e: any) => {
  if (e && e.length > 1) {
   const dateFrom = e[0]._d;
   const dateTo = e[1]._d;

   setDefaultDateRange(e);

   if (dateFrom) {
    setDateFrom(dateFrom);
   } else {
    setDateFrom(null);
   }

   if (dateTo) {
    setDateTo(dateTo);
   } else {
    setDateTo(null);
   }
  } else {
   setDateFrom(null);
   setDateTo(null);
   setDefaultDateRange(null);
  }
 };

 const { data: connections } = useQuery<Models.Connection[]>(
  ['connections', contractNumber],
  () => srv.getConnections(contractNumber)
 );

 const { data: meterings } = useQuery<Models.MeteringDevices[]>(
  ['meterings', meteringDevice],
  () => srv.getMeteringDeviceUnique(meteringDevice)
 );

 let {
  data: accruals,
  mutate: save,
  isLoading,
 } = useMutation(srv.getMeteringAccruals);

 const onFinish = useCallback(
  (typeDevice) => {
   save({
    contractId: contractNumber,
    meteringDeviceAisId: typeDevice,
    dateFrom: null,
    dateTo: null,
   });
  },
  [save, contractNumber]
 );

 const onFinishAskue = useCallback(
  (dates, typeDevice) => {
   let dateFrom = null;
   let dateTo = null;

   if (dates && dates.length > 1) {
    dateFrom = moment(dates[0]._d).format('YYYY-MM-DDTHH:mm:ss');
    dateTo = moment(dates[1]._d).format('YYYY-MM-DDTHH:mm:ss');
   }

   save({
    contractId: contractNumber,
    meteringDeviceAisId: typeDevice,
    dateFrom: dateFrom,
    dateTo: dateTo,
   });
  },
  [save, contractNumber]
 );

 return {
  changeContract,
  changeConnection,
  changeTypeDevice,
  handleDateRangeValues,
  dateFrom,
  dateTo,
  defaultDateRange,
  typeDevice,
  contractNumber,
  meteringDevice,
  onFinish,
  onFinishAskue,
  connections,
  meterings,
  contracts,
  isLoading,
  accruals: accruals?.history,
  accrualsAskue: accruals?.historyAskue,
 };
}
